// VFX: Semantic Glow Dark
// Category: gradient-shift  ·  Tags: background, semantic, glow, dark, problem
// Radial color glow shifting by narrative phase.
import React from "react";
import {AbsoluteFill, useCurrentFrame, interpolateColors} from "remotion";
export const SemanticGlowDark: React.FC<{
  phase?: "problem"|"solution"|"neutral"|"discovery"|"cta";
  animated?: boolean; intensity?: number;
}> = ({phase="problem", animated=true, intensity=1}) => {
  const frame = useCurrentFrame();
  const phaseColors: Record<string, string> = {
    problem: "#ef4444", solution: "#34d399", neutral: "#6366f1",
    discovery: "#f59e0b", cta: "#ec4899",
  };
  const color = phaseColors[phase] || "#6366f1";
  const pulse = animated ? Math.sin(frame * 0.04) * 0.06 * intensity + 0.16 * intensity : 0.18 * intensity;
  const pulse2 = animated ? Math.sin(frame * 0.06 + 1.5) * 0.04 + 0.08 : 0.08;
  return (
    <AbsoluteFill style={{background:"#060608"}}>
      <div style={{
        position:"absolute", inset:0,
        background:`radial-gradient(ellipse 65% 50% at 50% 35%, ${color}${Math.round(pulse*255).toString(16).padStart(2,"0")} 0%, transparent 60%)`,
      }} />
      <div style={{
        position:"absolute", inset:0,
        background:`radial-gradient(ellipse 35% 28% at 20% 80%, ${color}${Math.round(pulse2*255).toString(16).padStart(2,"0")} 0%, transparent 55%)`,
      }} />
      <div style={{
        position:"absolute", inset:0,
        backgroundImage:"url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.06'/%3E%3C/svg%3E\")", opacity:0.5,
      }} />
    </AbsoluteFill>
  );
};

export default function BgSemanticGlowDarkLoop() {
  return <SemanticGlowDark />;
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
